"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
const _ = __importStar(require("lodash"));
const vue_property_decorator_1 = require("vue-property-decorator");
const vue_class_component_1 = require("vue-class-component");
const core_1 = require("@integro/core");
let BtnReportInvoiceData = class BtnReportInvoiceData extends (0, vue_class_component_1.mixins)(core_1.UserComponentMixin) {
    componentMetadata = {
        kind: "usercontrol",
    };
    beforeCreate() {
    }
    resource;
    onResource(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("resource");
    }
    confirmMessage;
    onConfirm_message(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("confirmMessage");
    }
    size;
    onSize(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("size");
    }
    messages;
    ux;
    dataMembers = ['messages', 'ux'];
    data() {
        return {
            ...this.mixinData(),
            actions: this.getActions(),
            ...{
                messages: {
                    bntText: "NAV adatszolgáltatás",
                    btnTooltip: "NAV adatszolgáltatás",
                },
                ux: null,
            },
        };
    }
    async act_7315092382398562_emit_7366_getActionArgs($event) {
        return {
            event: "success",
        };
    }
    async act_7315092382398562_request_7364_getActionArgs($event) {
        return {
            operation: "sync_invoice",
            data: { id: this.resource.id, target: 'nav' },
        };
    }
    async act_7315092382398562_request_7364_getConfirm($event) {
        return {
            header: "NAV adatszolgáltatás",
            message: this.confirmMessage,
            btnOk: "Adatszolgáltatás indítása",
            btnCancel: "Mégsem",
            severity: "warning",
        };
    }
    async evh_7315092382398562_clickPreventStop(event, scope) {
        return await this.actions.evh_7315092382398562_clickPreventStop.executeFromDOM(this, event, scope);
    }
    actions;
    getActions() {
        const act_7315092382398562_emit_7366 = new core_1.actions.EmitAction({
            actionArgs: this.act_7315092382398562_emit_7366_getActionArgs,
            events: [],
        });
        const evh_7315092382398562_success_7365 = new core_1.actions.EventHandlerImpl({
            action: act_7315092382398562_emit_7366,
            event: "success",
            displayName: "emit",
        });
        const act_7315092382398562_request_7364 = new core_1.actions.RequestAction({
            actionArgs: this.act_7315092382398562_request_7364_getActionArgs,
            confirm: this.act_7315092382398562_request_7364_getConfirm,
            displayName: "submit",
            events: [evh_7315092382398562_success_7365],
        });
        const evh_7315092382398562_clickPreventStop_7363 = new core_1.actions.EventHandlerImpl({
            action: act_7315092382398562_request_7364,
            event: "click.prevent.stop",
            displayName: "submit",
        });
        const evh_7315092382398562_clickPreventStop = new core_1.actions.EventHandlerGroup({
            handlers: [evh_7315092382398562_clickPreventStop_7363],
        });
        return {
            act_7315092382398562_emit_7366,
            evh_7315092382398562_success_7365,
            act_7315092382398562_request_7364,
            evh_7315092382398562_clickPreventStop_7363,
            evh_7315092382398562_clickPreventStop,
            submit: act_7315092382398562_request_7364,
        };
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({
        required: true,
        type: Object,
    }),
    __metadata("design:type", Object)
], BtnReportInvoiceData.prototype, "resource", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('resource'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], BtnReportInvoiceData.prototype, "onResource", null);
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: String,
        default: "Kérem erősítse meg az adatszolgáltatás indítását.\n",
    }),
    __metadata("design:type", String)
], BtnReportInvoiceData.prototype, "confirmMessage", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('confirmMessage'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], BtnReportInvoiceData.prototype, "onConfirm_message", null);
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: String,
    }),
    __metadata("design:type", String)
], BtnReportInvoiceData.prototype, "size", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('size'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], BtnReportInvoiceData.prototype, "onSize", null);
BtnReportInvoiceData = __decorate([
    (0, vue_property_decorator_1.Component)()
], BtnReportInvoiceData);
exports.default = BtnReportInvoiceData;
vue_property_decorator_1.Vue.component("BtnReportInvoiceData", BtnReportInvoiceData);
